module.exports = __webpack_public_path__ + "static/media/map_menu_dropdown_arrow.f2581746.svg";